import { call } from '../@';

const deletePayment = (id: string) => call('payment-delete', { id });

export default deletePayment;
